export { PageTitleBlock } from './ui/pageTitleBlock';
export { PageSeoTitleBlock } from './ui/pageSeoTitleBlock';
export type { PageTitleBlockProps } from './ui/types';
